module.exports = __webpack_public_path__ + "img/emoji_spritesheet_0.cce267d0.png";